import { SvgIconProps } from '@mui/material';
import NotificationsTwoToneIcon from '@mui/icons-material/NotificationsTwoTone';
import LoginTwoToneIcon from '@mui/icons-material/LoginTwoTone';
import PaymentsTwoToneIcon from '@mui/icons-material/PaymentsTwoTone';
import SystemUpdateAltTwoToneIcon from '@mui/icons-material/SystemUpdateAltTwoTone';
import LockResetTwoToneIcon from '@mui/icons-material/LockResetTwoTone';
import DevicesOtherTwoToneIcon from '@mui/icons-material/DevicesOtherTwoTone';
import SupportAgentTwoToneIcon from '@mui/icons-material/SupportAgentTwoTone';
import AutorenewTwoToneIcon from '@mui/icons-material/AutorenewTwoTone';
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import CampaignTwoToneIcon from '@mui/icons-material/CampaignTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';

// Mirrors Common.Enums.Notifications.NotificationCategory on the server.
export enum NotificationCategory {
  General = 0,
  Security = 1,
  Billing = 2,
  AppUpdate = 3,
  Order = 4,
  Inventory = 5,
  Support = 6,
  Subscription = 7,
  Account = 8,
  Broadcast = 9
}

type IconType = React.ComponentType<SvgIconProps>;
type ThemeColor = 'primary' | 'info' | 'success' | 'warning' | 'error' | 'secondary';

export const CATEGORY_LABELS: Record<number, string> = {
  [NotificationCategory.General]: 'General',
  [NotificationCategory.Security]: 'Security',
  [NotificationCategory.Billing]: 'Billing',
  [NotificationCategory.AppUpdate]: 'App update',
  [NotificationCategory.Order]: 'Orders',
  [NotificationCategory.Inventory]: 'Inventory',
  [NotificationCategory.Support]: 'Support',
  [NotificationCategory.Subscription]: 'Subscription',
  [NotificationCategory.Account]: 'Account',
  [NotificationCategory.Broadcast]: 'Announcement'
};

// Tabs shown in the bell / inbox filter (subset most relevant to a store user).
export const FILTER_TABS: { label: string; type: number | null }[] = [
  { label: 'All', type: null },
  { label: 'Security', type: NotificationCategory.Security },
  { label: 'Billing', type: NotificationCategory.Billing },
  { label: 'Support', type: NotificationCategory.Support },
  { label: 'Updates', type: NotificationCategory.AppUpdate }
];

const ICON_BY_KEY: Record<string, IconType> = {
  login: LoginTwoToneIcon,
  devices: DevicesOtherTwoToneIcon,
  password: LockResetTwoToneIcon,
  payment: PaymentsTwoToneIcon,
  system_update: SystemUpdateAltTwoToneIcon,
  support: SupportAgentTwoToneIcon,
  subscription: AutorenewTwoToneIcon,
  store: StorefrontTwoToneIcon,
  inventory: Inventory2TwoToneIcon,
  order: ShoppingCartTwoToneIcon,
  broadcast: CampaignTwoToneIcon
};

const ICON_BY_CATEGORY: Record<number, IconType> = {
  [NotificationCategory.General]: NotificationsTwoToneIcon,
  [NotificationCategory.Security]: LockResetTwoToneIcon,
  [NotificationCategory.Billing]: PaymentsTwoToneIcon,
  [NotificationCategory.AppUpdate]: SystemUpdateAltTwoToneIcon,
  [NotificationCategory.Order]: ShoppingCartTwoToneIcon,
  [NotificationCategory.Inventory]: Inventory2TwoToneIcon,
  [NotificationCategory.Support]: SupportAgentTwoToneIcon,
  [NotificationCategory.Subscription]: AutorenewTwoToneIcon,
  [NotificationCategory.Account]: StorefrontTwoToneIcon,
  [NotificationCategory.Broadcast]: CampaignTwoToneIcon
};

export function categoryLabel(type: number): string {
  return CATEGORY_LABELS[type] ?? 'Notification';
}

export function notificationIcon(type: number, iconKey?: string): IconType {
  if (iconKey && ICON_BY_KEY[iconKey]) return ICON_BY_KEY[iconKey];
  return ICON_BY_CATEGORY[type] ?? NotificationsTwoToneIcon;
}

export function severityColor(severity?: string): ThemeColor {
  switch ((severity || '').toLowerCase()) {
    case 'success': return 'success';
    case 'warning': return 'warning';
    case 'error': return 'error';
    case 'info': return 'info';
    default: return 'primary';
  }
}
